import { MenuTabsWrap } from 'features/menu/components/menu-tabs';
import FavoritesCardList from 'features/menu/pages/favorites-page/favorites-card-list';
import { useStoreRequired } from 'features/store/hooks/use-store-required';

export default function MenuFavoritesRoute() {
  useStoreRequired();

  return (
    <MenuTabsWrap>
      <FavoritesCardList />
    </MenuTabsWrap>
  );
}
